import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

const STORAGE_KEY = "admin-sidebar-open-groups"

export default class extends Controller {
  static targets = ["group"]

  connect() {
    this.rememberListener = this.remember.bind(this)
    this.restore()
    this.element.addEventListener("shown.bs.collapse", this.rememberListener)
    this.element.addEventListener("hidden.bs.collapse", this.rememberListener)
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.collapse", this.rememberListener)
    this.element.removeEventListener("hidden.bs.collapse", this.rememberListener)
  }

  restore() {
    const openKeys = this.storedKeys()

    for (const group of this.groupTargets) {
      const shouldOpen = openKeys ? openKeys.includes(group.dataset.groupKey) : group.querySelector(".active") !== null

      if (shouldOpen) this.openWithoutAnimating(group)
    }
  }

  // Collapse#show() animates, which is right for a click but replays the
  // unfold on every page load. Set the open state directly and instantiate
  // afterwards so Bootstrap adopts it (its constructor reads the show class).
  openWithoutAnimating(group) {
    group.classList.add("show")
    bootstrap.Collapse.getOrCreateInstance(group, { toggle: false })

    for (const toggle of this.element.querySelectorAll(`[data-bs-target="#${group.id}"]`)) {
      toggle.classList.remove("collapsed")
      toggle.setAttribute("aria-expanded", "true")
    }
  }

  remember() {
    const openKeys = this.groupTargets.filter((group) => group.classList.contains("show")).map((group) => group.dataset.groupKey)

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(openKeys))
    } catch {
      // storage unavailable (private mode): forgetting the open group is fine
    }
  }

  storedKeys() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY)

      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  }
}
